
import { formatTimestampView } from '../utils/functions';
import './BasicTable.css'

export const YarnColumns = [
    /*{
        // aus den columns id entfernen, wenn sie nicht in der Tabelle erscheinen soll
        Header: 'Id', 
        accessor: 'id_yarn',
        disableFilters: true, // Filtermöglichkeit für id entfernt
        sticky: 'left' // Spalte links fixieren
    },*/
    {
        Header: 'Bezeichnung',
        accessor: 'name',
        sticky: 'left' // Spalte links fixieren
    },
    {
        Header: 'Letzte Änderung',
        accessor: 'timestamp',
        /*Cell: ({ value }) => formatTimestampView(value),*/
        Cell: ({ value }) => formatTimestampView(value),
            sortType: (rowB, rowA) => {
            // Direktes Vergleichen der Timestamp-Werte für korrektes Sortieren
            const timestampA = rowA.values.timestamp;
            const timestampB = rowB.values.timestamp;

            return new Date(timestampB) - new Date(timestampA);
        }
    },
    {
        Header: 'Hersteller',
        accessor: 'manufacturer_name', // dropdown
    },
    {
        Header: 'Institution',
        accessor: 'institution_name', // wird nur in Tabelle angezeigt
    },
    {
        Header: 'Gesamtdurchmesser',
        accessor: (row) => {
            // Kombiniere Durchmesser und Einheit
            const diameter = row.diameter;
            const unit = row.unit_diameter_name;
            if (!diameter && !unit) return null; // Fallback, falls Werte fehlen            
            return `${diameter} ${unit}`;
          },

        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const diameter = parseFloat(value);
                if (isNaN(diameter)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "mm":
                        return diameter * 1000 ; // 1 mm = 1000 µm
                    case "µm":
                        return diameter; // bereits in µm
                    default:
                        return diameter; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Gesamtdurchmesser']);
            const mmsB = convertToMM(rowB.values['Gesamtdurchmesser']);           
            return mmsA - mmsB;
        },

        /*accessor: row => `${row.diameter} ${row.unit_diameter_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Feinheit',
        accessor: (row) => {
            // Kombiniere Feinheit und Einheit
            const yarn_fineness = row.yarn_fineness;
            const unit = row.unit_yarn_fineness_name;
            if (!yarn_fineness && !unit) return null; // Fallback, falls Werte fehlen            
            return `${yarn_fineness} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);      
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const yarn_fineness = parseFloat(value);
                if (isNaN(yarn_fineness)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "tex":
                        return yarn_fineness * 10; // 1 tex = 10 dtex
                    case "dtex":
                        return yarn_fineness; // bereits in dtex
                    default:
                        return yarn_fineness; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Feinheit']);
            const mmsB = convertToMM(rowB.values['Feinheit']);           
            return mmsA - mmsB;
        },
        

        /*accessor: row => `${row.yarn_fineness} ${row.unit_yarn_fineness_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Material',
        accessor: 'material_name', // dropdown - vorhanden für alle Materialien
    },
    {
        Header: 'eigenes Material',
        accessor: 'material_own', // Textfeld zur Eingabe von Materialien, die nicht in Material enthalten sind
    },
    {
        Header: 'Oberflächenmaterial',
        accessor: 'material_coated_name', // dropdown - vorhanden für alle Materialien
    },
    {
        Header: 'eigenes Oberflächenmaterial',
        accessor: 'material_coated_own', // Textfeld zur Eingabe von Materialien, die nicht in Material enthalten sind
    },
    {
        Header: 'Aufbau',
        accessor: 'structure_name', // dropdown
    },
    {
        Header: 'Elektr. Widerstand',
        accessor: (row) => {
            // Kombiniere Widerstand und Einheit
            const electrical_resistivity = row.electrical_resistivity;
            const unit = row.unit_electrical_resistivity_name;
            if (!electrical_resistivity && !unit) return null; // Fallback, falls Werte fehlen            
            return `${electrical_resistivity} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);      
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const electrical_resistivity = parseFloat(value);
                if (isNaN(electrical_resistivity)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "Ω/mm":
                        return electrical_resistivity * 1000; // 1 tex = 10 dtex
                    case "Ω/cm":
                        return electrical_resistivity * 100; // bereits in dtex
                    case "Ω/m":
                        return electrical_resistivity; // bereits in Ω/m
                    default:
                        return electrical_resistivity; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Elektr. Widerstand']);
            const mmsB = convertToMM(rowB.values['Elektr. Widerstand']);           
            return mmsA - mmsB;
        },
        
               
        /*accessor: row => `${row.electrical_resistivity} ${row.unit_electrical_resistivity_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Waschbarkeit',
        accessor: row => `${row.washability_cycles}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return numericValue < 0 ? '' : value;
        },
    },
    {
        Header: 'UV-Beständigkeit',
        accessor: 'uv_resistance',
    },
    {
        Header: 'Flexibilität',
        accessor: row => `${row.flexibility} ${row.unit_flexibility_name}`,
        disableSortBy: true,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
    },
    {
        Header: 'Eigenerwärmung bei Stromfluss',
        accessor: row => `${row.self_heating} ${row.unit_self_heating_name}`,
        disableSortBy: true,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
    },
    {
        Header: 'Veränderung der Flexibilität',
        accessor: 'change_flexibility',
    },
    {
        Header: 'Rauigkeit / Struktur',
        accessor: 'coating_structure', // dropdown
    },
    {
        Header: 'Haftung der Beschichtung',
        accessor: (row) => {
            // Kombiniere Haftung und Einheit
            const coating_adhesion = row.coating_adhesion;
            const unit = row.unit_coating_adhesion_name;
            if (!coating_adhesion && !unit) return null; // Fallback, falls Werte fehlen            
            return `${coating_adhesion} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);      
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const coating_adhesion = parseFloat(value);
                if (isNaN(coating_adhesion)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "N":
                        return coating_adhesion * 100; // 1 N = 100 cN
                    case "cN":
                        return coating_adhesion; // bereits in cN
                    default:
                        return coating_adhesion; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Haftung der Beschichtung']);
            const mmsB = convertToMM(rowB.values['Haftung der Beschichtung']);           
            return mmsA - mmsB;
        },
        
        
        /*accessor: row => `${row.coating_adhesion} ${row.unit_coating_adhesion_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },*/

    },
    {
        Header: 'Veränderung der Haftung der Beschichtung',
        accessor: 'change_coating_adhesion',
    },  
    {
        Header: 'Stabilität der Beschichtung',
        accessor: (row) => {
            // Kombiniere Haftung und Einheit
            const coating_stability = row.coating_stability;
            const unit = row.unit_coating_stability_name;
            if (!coating_stability && !unit) return null; // Fallback, falls Werte fehlen            
            return `${coating_stability} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);      
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const coating_stability = parseFloat(value);
                if (isNaN(coating_stability)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "N":
                        return coating_stability * 100; // 1 N = 100 cN
                    case "cN":
                        return coating_stability; // bereits in cN
                    default:
                        return coating_stability; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Stabilität der Beschichtung']);
            const mmsB = convertToMM(rowB.values['Stabilität der Beschichtung']);           
            return mmsA - mmsB;
        },
        
        
        /*accessor: row => `${row.coating_stability} ${row.unit_coating_stability_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Max. zulässige Temperatur',
        accessor: (row) => {
            // Kombiniere Temperatur und Einheit
            const max_temperature = row.max_temperature;
            const unit = row.unit_max_temperature_name;
            if (!max_temperature && !unit) return null; // Fallback, falls Werte fehlen            
            return `${max_temperature} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);      
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const max_temperature = parseFloat(value);
                if (isNaN(max_temperature)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "°C":
                        return max_temperature + 273 ; // 0 °C ==> 273 K
                    case "K":
                        return max_temperature; // bereits in K
                    default:
                        return max_temperature; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Max. zulässige Temperatur']);
            const mmsB = convertToMM(rowB.values['Max. zulässige Temperatur']);           
            return mmsA - mmsB;
        },


        /*accessor: row => `${row.max_temperature} ${row.unit_max_temperature_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },*/

    },
    {
        Header: 'Sonstige',
        accessor: 'others',
    },
    {
        Header: (
            <div style={{ transform: 'rotate(-90deg)', width: '45px', height: '40px', textAlign: 'left' }}>
                Rezept Anzahl
            </div>
        ),
        accessor: 'count_in_recipe',
        disableFilters: true, // Filtermöglichkeit für id entfernt
    }
]
